import type { FC, SVGProps } from 'react';
import IllustrationAlert from './illustrations/illustration-alert.svg?react';
import IllustrationDarkWeb from './illustrations/illustration-dark-web.svg?react';
import IllustrationDataBroker from './illustrations/illustration-data-broker.svg?react';
import IllustrationGroup from './illustrations/illustration-group.svg?react';
import IllustrationId from './illustrations/illustration-id.svg?react';
import IllustrationIdentityProtection from './illustrations/illustration-identity-protection.svg?react';
import IllustrationKey from './illustrations/illustration-key.svg?react';
import IllustrationLogomark from './illustrations/illustration-logomark.svg?react';
import IllustrationMobileVerified from './illustrations/illustration-mobile-verified.svg?react';
import IllustrationProfilePicture from './illustrations/illustration-profile-picture.svg?react';
import IllustrationQuestion from './illustrations/illustration-question.svg?react';
import IllustrationTechSupport from './illustrations/illustration-tech-support.svg?react';

export type SharedIllustrationName =
  | 'alert'
  | 'dark-web'
  | 'data-broker'
  | 'group'
  | 'id'
  | 'identity-protection'
  | 'key'
  | 'logomark'
  | 'mobile-verified'
  | 'profile-picture'
  | 'question'
  | 'tech-support';

interface SharedIllustrationProps extends SVGProps<SVGSVGElement> {
  name: SharedIllustrationName;
  size?: 40 | 64 | 88;
  color?: string;
}

const illustrationMap: Record<
  SharedIllustrationName,
  FC<SVGProps<SVGSVGElement>>
> = {
  alert: IllustrationAlert,
  'dark-web': IllustrationDarkWeb,
  'data-broker': IllustrationDataBroker,
  group: IllustrationGroup,
  id: IllustrationId,
  'identity-protection': IllustrationIdentityProtection,
  key: IllustrationKey,
  logomark: IllustrationLogomark,
  'mobile-verified': IllustrationMobileVerified,
  'profile-picture': IllustrationProfilePicture,
  question: IllustrationQuestion,
  'tech-support': IllustrationTechSupport,
};

export const SharedIllustration: FC<SharedIllustrationProps> = ({
  name,
  size = 64,
  color = 'currentColor',
  style,
  ...props
}) => {
  const IllustrationComponent = illustrationMap[name];

  if (!IllustrationComponent) {
    return null;
  }

  return (
    <IllustrationComponent
      {...props}
      width={size}
      height={size}
      style={{ ...style, minWidth: size, fill: color }}
      aria-hidden="true"
    />
  );
};
